export const MESSAGING_PROTOCOL_VERSION = '3.0.0';
export type MessagingProtocolVersion = typeof MESSAGING_PROTOCOL_VERSION;
